export * from './objekt-arts-sorter.component';
export * from './objekt-arts-sorter.component.module';